var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVegvizerLogoSidebar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_44_1",
    "data-name": "Component 44 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.146,
    height: 41.68,
    viewBox: "0 0 41.146 41.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(-21.582 -19.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(2007.583 -80.734) rotate(139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1567.745,1328.488l8.573-27.921-26.63,12.225Zm-2.07-6.715-8.752-7.608,12.858-5.7Z",
    transform: "translate(-0.001 -114.664)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(1551.081 1181.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1807.23,1505.3l.012.01h0Z",
    transform: "translate(-1798.102 -1492.5)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1596.621,1181.759l-20.123,9.657,5.614,4.845,7.9,6.819,3.845-12.457.018-.009Zm-10.983,12.809h0l-2.7-2.343,7.882-3.968-.9,3.025-1.652,5.439Z",
    transform: "translate(-1576.498 -1181.759)",
    fill: "#69efad"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 10.275,
    y2: 5.007,
    transform: "translate(1557.371 1194.394)",
    fill: "#9cff95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1555.175,1497.858l7.68-3.723-1.749-3.833s-8.384,3.731-11.435,5.209",
    transform: "translate(0 -297.417)",
    fill: "#9460f5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegvizerLogoSidebar);
export default __webpack_public_path__ + "static/media/vegvizerLogoSidebar.2321228385946fc6972919f2ea4890ef.svg";
export { ForwardRef as ReactComponent };